import React from 'react'

import clsx from 'clsx'

import { NotificationTheme } from './NotificationTheme'

export interface NotificationProps {
  action?: React.ReactNode
  children: React.ReactNode
  theme?: NotificationTheme
  className?: string
  color?: 'default' | 'success' | 'alert' | 'notice'
  icon?: React.ReactNode
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl'
  variant?: 'outlined' | 'contained'
}

export default function Notification({
  action,
  children,
  className,
  color = 'default',
  icon,
  size = 'base',
  theme = NotificationTheme,
  variant = 'contained',
  ...props
}: NotificationProps) {
  return (
    <div
      className={clsx(
        theme.block,
        theme.modifiers?.size[size],
        theme.variants && theme.variants[variant].block,
        theme.variants && theme.variants[variant].modifiers[color],
        className
      )}
      {...props}
    >
      <div className='flex flex-1 items-center justify-between'>
        <div className='flex flex-1 items-center'>
          {icon ? <div className={clsx(theme.elements?.icon)}>{icon}</div> : null}
          <div className={clsx(icon && 'ml-6', action && 'mr-6', theme.elements?.message)}>{children}</div>
        </div>
        {action ? <div className={clsx(theme.elements?.action)}>{action}</div> : null}
      </div>
    </div>
  )
}
